export const toQuery = (data) => {
  return Object.keys(data)
    .map(key => {
      if (Array.isArray(data[key])) {
        const encodedValues = data[key].map(value => encodeURIComponent(value)).join(',');
        return `${encodeURIComponent(key.replaceAll(' ', '_'))}=${encodedValues}`;
      } else if (key === 'sort') {
        return `${encodeURIComponent(key)}=${data[key]}`;
      } else if (typeof data[key] === 'object' && 'replaceAll' in data[key] && typeof data[key].replaceAll === 'function') {
        return `${encodeURIComponent(key.replaceAll(' ', '_'))}=${encodeURIComponent(data[key])}`;
      } else {
        return `${encodeURIComponent(key.replaceAll(' ', '_'))}=${encodeURIComponent(data[key])}`;
      }
    })
    .join('&');
};



// WEBPACK FOOTER //
// ./src/utils/requests.js